import React, { useState } from 'react';
import { Table } from 'antd';
import { Tag } from 'ui';
import { useT } from 'hooks/Locale/useT';
import CommentModal from '../Modals/CommentModal';
import { TagStatus } from 'ui/Tag/types';
import generalHelpers from 'utils/generalHelpers';
import GradingModel from 'components/Grading/GradingModal';
import RegenerateTaskButton from 'components/Grading/RegenerateTaskButton';

interface AssignmentTableInterface {
    data: any[];
    onReload?: Function;
}

const AssignmentTable: React.FC<AssignmentTableInterface> = ({ data, onReload }) => {
    const t = useT();
    const [showCommentModal, setShowCommentModal] = useState<any>([]);
    const [selectedAttemptData, setSelectedAttemptData] = useState<any>(null);

    const columns = [
        {
            title: t('program.attempt'),
            render: (_text: string, record: any) =>
                t('program.attempt_count', { attempt: record.attempt }),
        },
        {
            title: t('student.result'),
            dataIndex: 'resultStr',
            render: (resultStr: string) => resultStr,
        },
        {
            title: t('general.status'),
            dataIndex: 'status',
            render: (status: TagStatus) => (status ? <Tag status={status} /> : null),
        },
        {
            title: t('program.attempt_start'),
            dataIndex: 'attemptStart',
        },
        {
            title: t('program.attempt_end'),
            dataIndex: 'attemptEnd',
        },
        {
            title: t('program.result_comment'),
            render: (_text: string, record: any) => (
                <div
                    className={'pointer'}
                    onClick={() => (record?.comment ? setShowCommentModal(record.comment) : null)}
                >
                    <i className="fa-sharp fa-regular fa-comment-check"></i>
                </div>
            ),
        },
        {
            title: t('program.total_timFe_spent'),
            dataIndex: 'timeSpent',
            render: (time: number) => (time ? generalHelpers.toHoursAndMinutes(time) : '-'),
        },
        {
            title: t('grading.view'),
            render: (_text: string, record: any) => {
                // 24.3.8: a deleted grading task can be regenerated by PowerAdmin
                if (record.gradingTaskDeleted) {
                    return (
                        <RegenerateTaskButton
                            attemptId={record.attemptId}
                            onDone={() => onReload?.()}
                        />
                    );
                }

                if (!record.attemptId || !record.submissionId) {
                    return null;
                }

                // 24.3.9: grade view/edit entry point (same grading modal as "Vērtēšana")
                return (
                    <div
                        className="pointer"
                        onClick={() => {
                            setSelectedAttemptData({
                                attemptId: record.attemptId,
                                type: 'ASSIGNMENT',
                                submissionId: record.submissionId,
                            });
                        }}
                    >
                        <i className="fa-sharp fa-light fa-diagram-subtask"></i>
                    </div>
                );
            },
        },
    ];

    return (
        <>
            <Table
                columns={columns}
                dataSource={data}
                rowKey={'id'}
                pagination={{ position: [] }}
            />
            <CommentModal open={showCommentModal} onCancel={setShowCommentModal} />
            <GradingModel
                onCancel={() => {
                    setSelectedAttemptData(null);
                }}
                attemptData={selectedAttemptData}
                onGraded={() => {
                    setSelectedAttemptData(null);
                    onReload?.();
                }}
            />
        </>
    );
};

export default AssignmentTable;
